import { render, staticRenderFns } from "./InfoBoxes.vue?vue&type=template&id=1e0d2545&"
import script from "./InfoBoxes.vue?vue&type=script&lang=coffee&"
export * from "./InfoBoxes.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports